/* NIMBLI — page Qui sommes-nous. Actes I, II et III.
   18/08/2026, revu le 19/08/2026.

   Ce fichier ne fait que deux choses, et rien d autre.

   1. L INERTIE. Le brief demande que le mouvement continue legerement apres
      le scroll avant de se stabiliser. Les timelines CSS ne savent pas faire
      ca : elles sont strictement liees a la position de scroll, donc elles
      s arretent net. On calcule donc un retard amorti et on l ecrit dans une
      variable CSS, que seuls les plans d atmosphere consomment, en transform.

   2. UN REPLI POUR LES NAVIGATEURS SANS TIMELINE. La ou animation-timeline
      n existe pas, on remplace les revelations au scroll par de simples
      transitions declenchees a l entree dans le champ. Pas de parallaxe :
      seulement l apparition, pour que la page ne soit pas figee.

   19/08 — la page compte desormais plusieurs actes, donc plusieurs racines
   [data-nimbli-qsn]. La version precedente ne prenait que la premiere : le
   repli des actes II et III ne se serait jamais declenche. On les traite
   toutes. La variable d inertie reste ecrite sur chaque racine et non sur
   :root, parce que chaque acte declare son propre --qsn-inertie: 0px, qui
   masquerait une valeur heritee.

   Si quoi que ce soit echoue, la page reste entierement lisible : aucun
   contenu n est masque par du JavaScript, tout est visible par defaut et
   c est le CSS qui decide de l animer ou non.

   Respecte prefers-reduced-motion : dans ce cas ce fichier ne fait rien. */

(function () {
  var racines = document.querySelectorAll('[data-nimbli-qsn]');
  if (!racines.length) { return; }

  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (calme && calme.matches) { return; }

  /* ---------------------------------------------------------- 1. inertie */

  var supporteTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  var courant = window.scrollY || 0;
  var boucleActive = false;

  /* L etat de visibilite est marque sur la racine elle-meme, pas compte dans
     un total : l observateur emet une entree par element au demarrage, y
     compris pour ceux qui sont hors champ, et un simple compteur +1 / -1
     partait alors en negatif — la boucle ne demarrait jamais. */
  function auMoinsUneVue() {
    for (var i = 0; i < racines.length; i++) {
      if (racines[i].qsnVisible) { return true; }
    }
    return false;
  }

  function boucle() {
    if (!auMoinsUneVue()) { boucleActive = false; return; }
    var cible = window.scrollY || 0;
    courant += (cible - courant) * 0.075;
    var retard = cible - courant;
    if (retard > 90) { retard = 90; }
    if (retard < -90) { retard = -90; }
    var valeur = retard.toFixed(2) + 'px';
    for (var i = 0; i < racines.length; i++) {
      racines[i].style.setProperty('--qsn-inertie', valeur);
    }
    window.requestAnimationFrame(boucle);
  }

  function reveiller() {
    if (boucleActive) { return; }
    boucleActive = true;
    courant = window.scrollY || 0;
    window.requestAnimationFrame(boucle);
  }

  if (window.IntersectionObserver) {
    var veille = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        entrees[i].target.qsnVisible = entrees[i].isIntersecting;
      }
      if (auMoinsUneVue()) { reveiller(); }
    }, { rootMargin: '10% 0px' });
    for (var k = 0; k < racines.length; k++) { veille.observe(racines[k]); }
  } else {
    for (var t = 0; t < racines.length; t++) { racines[t].qsnVisible = true; }
    reveiller();
  }

  /* ------------------------------------------------------------ 2. repli */

  if (supporteTimeline || !window.IntersectionObserver) { return; }

  var aRevele = [];
  for (var m = 0; m < racines.length; m++) {
    racines[m].classList.add('qsn-sans-timeline');
    var trouves = racines[m].querySelectorAll(
      '.qsn-ligne, .qsn-fondu, .qsn-cadre, .qsn2-ligne, .qsn2-fondu, .qsn2-fenetre, .qsn3-ligne, .qsn3-fondu'
    );
    for (var n = 0; n < trouves.length; n++) { aRevele.push(trouves[n]); }
  }
  if (!aRevele.length) { return; }

  var oeil = new IntersectionObserver(function (entrees) {
    for (var i = 0; i < entrees.length; i++) {
      if (entrees[i].isIntersecting) {
        entrees[i].target.classList.add('qsn-vu');
        oeil.unobserve(entrees[i].target);
      }
    }
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  for (var j = 0; j < aRevele.length; j++) { oeil.observe(aRevele[j]); }
})();
